import { render, staticRenderFns } from "./PaidOrder.vue?vue&type=template&id=58f38dec&"
import script from "./PaidOrder.vue?vue&type=script&lang=js&"
export * from "./PaidOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports